export interface IFileInfo {
  id?: string
  folderType?: string
  name?: string
  fileExtension?: string
  type?: string
  url?: string
  hash?: string
}

export type THeaderOperates = 'share' | 'download' | 'more'

export enum EConsumerEvents {
  CLOSE_PAGE = 'pp-consumer-close',
  SHOW_HEADER = 'pp-consumer-show-header',
  CHECK_LOGIN_STATUS = 'pp-consumer-check-login-status',
  KEYDOWN = 'pp-consumer-keydown',
  FEEDBACK_SUCCESS = 'pp-feedback-success',
}

export interface IConsumerEventClosePageParams {
  file?: string
  scene?: string
}

export interface IConsumerEventShowHeaderParams {
  styleTheme?: {
    zIndex?: number
    textColor?: string
    textHoverColor?: string
  }
  centerLabel?: string
  leftOperates?: Array<'share' | 'download' | 'more'>
  hidePosition?: Array<'left' | 'right' | 'center' | 'all'>
}

export type TConsumerEventParams = IConsumerEventClosePageParams | IConsumerEventShowHeaderParams

// export type WildcardHandler = Parameters<ReturnType<typeof createContentConsumer>['emitter']['on']>[1]

export type WildcardHandler = (type: string | symbol, event: unknown) => void
